export enum UIUpdateEvent {
    Win = "win",
    Bangup_win = "bangup_win",
    TempWin = "temp_win",
    ClearWin = "clear_win",
    Balance = "balance",
    Autoplay = "autoplay",
    Bet = "bet",
    InfoBar = "InfoBar",
    Settings = "settings",
    FreeGames = "FreeGames",
    FreeSpins = "FreeSpins",
    ClearFreeSpins = "ClearFreeSpins",
    All = "all"
}
